
import React, { useState } from "react";

const fileStructure = [
  {
    name: "Account creation example",
    type: "folder",
    children: [
      { name: "model.pnml", type: "uploadPetrinet", path: "/files/example/model.pnml" },
      { name: "annotations.xml", type: "uploadAnnotations", path: "/files/example/annotations.xml" },
      { name: "obligations.xml", type: "uploadObligations", path: "/files/example/obligations.xml" },
      { name: "obligations_v.xml", type: "uploadObligations", path: "/files/example/obligations_v.xml" }
    ]
  },
  {
    name: "1An_kg4m",
    type: "folder",
    children: [
      { name: "1An_kg4m.pnml", type: "uploadPetrinet", path: "/files/1An_kg4m/1An_kg4m.pnml" },
      { name: "1An_kg4m_U3_W1.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W1.xml" },
      { name: "1An_kg4m_U3_W1_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W1_v.xml" },
      { name: "1An_kg4m_U10_W1.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W1.xml" },
      { name: "1An_kg4m_U10_W1_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W1_v.xml" },
      { name: "1An_kg4m_U3_W2.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W2.xml" },
      { name: "1An_kg4m_U3_W2_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W2_v.xml" },
      { name: "1An_kg4m_U10_W2.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W2.xml" },
      { name: "1An_kg4m_U10_W2_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W2_v.xml" },
      { name: "1An_kg4m_U3_W3.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W3.xml" },
      { name: "1An_kg4m_U3_W3_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U3_W3_v.xml" },
      { name: "1An_kg4m_U10_W3.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W3.xml" },
      { name: "1An_kg4m_U10_W3_v.xml", type: "uploadAnnotations", path: "/files/1An_kg4m/1An_kg4m_U10_W3_v.xml" },
      { name: "obligations.xml", type: "uploadObligations", path: "/files/1An_kg4m/obligations.xml" }
    ]
  },
  {
    name: "1Ex_eqm0",
    type: "folder",
    children: [
      { name: "1Ex_eqm0.pnml", type: "uploadPetrinet", path: "/files/1Ex_eqm0/1Ex_eqm0.pnml" },
      { name: "1Ex_eqm0_U3_W1.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W1.xml" },
      { name: "1Ex_eqm0_U3_W1_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W1_v.xml" },
      { name: "1Ex_eqm0_U10_W1.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W1.xml" },
      { name: "1Ex_eqm0_U10_W1_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W1_v.xml" },
      { name: "1Ex_eqm0_U3_W2.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W2.xml" },
      { name: "1Ex_eqm0_U3_W2_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W2_v.xml" },
      { name: "1Ex_eqm0_U10_W2.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W2.xml" },
      { name: "1Ex_eqm0_U10_W2_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W2_v.xml" },
      { name: "1Ex_eqm0_U3_W3.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W3.xml" },
      { name: "1Ex_eqm0_U3_W3_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U3_W3_v.xml" },
      { name: "1Ex_eqm0_U10_W3.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W3.xml" },
      { name: "1Ex_eqm0_U10_W3_v.xml", type: "uploadAnnotations", path: "/files/1Ex_eqm0/1Ex_eqm0_U10_W3_v.xml" },
      { name: "obligations.xml", type: "uploadObligations", path: "/files/1Ex_eqm0/obligations.xml" }
    ]
  },
    {
      name: "1Ve_m5og",
      type: "folder",
      children: [
        { name: "1Ve_m5og.pnml", type: "uploadPetrinet", path: "/files/1Ve_m5og/1Ve_m5og.pnml" },
        { name: "1Ve_m5og_U3_W1.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W1.xml" },
        { name: "1Ve_m5og_U3_W1_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W1_v.xml" },
        { name: "1Ve_m5og_U10_W1.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W1.xml" },
        { name: "1Ve_m5og_U10_W1_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W1_v.xml" },
        { name: "1Ve_m5og_U3_W2.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W2.xml" },
        { name: "1Ve_m5og_U3_W2_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W2_v.xml" },
        { name: "1Ve_m5og_U10_W2.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W2.xml" },
        { name: "1Ve_m5og_U10_W2_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W2_v.xml" },
        { name: "1Ve_m5og_U3_W3.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W3.xml" },
        { name: "1Ve_m5og_U3_W3_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U3_W3_v.xml" },
        { name: "1Ve_m5og_U10_W3.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W3.xml" },
        { name: "1Ve_m5og_U10_W3_v.xml", type: "uploadAnnotations", path: "/files/1Ve_m5og/1Ve_m5og_U10_W3_v.xml" },
        { name: "obligations.xml", type: "uploadObligations", path: "/files/1Ve_m5og/obligations.xml" }
      ]
    }
];


function FilePopup({ fileType, onSelect, onClose }) {
  const [expandedFolders, setExpandedFolders] = useState({});

  const toggleFolder = (folderName) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderName]: !prev[folderName]
    }));
  };

  const renderItems = (items) => {
    return items.map((item) => {
      if (item.type === "folder") {
        const isExpanded = expandedFolders[item.name];
        return (
          <div key={item.name} style={{ marginBottom: "8px" }}>
            <div
              style={{ fontWeight: "bold", cursor: "pointer" }}
              onClick={() => toggleFolder(item.name)}
            >
              {isExpanded ? "📂" : "📁"} {item.name}
            </div>
            {isExpanded && (
              <div style={{ marginLeft: "20px" }}>
                {renderItems(item.children)}
              </div>
            )}
          </div>
        );
      } else {
        const isEnabled = item.type === fileType;
        return (
          <div
            key={item.name}
            style={{
              padding: "5px",
              cursor: isEnabled ? "pointer" : "not-allowed",
              opacity: isEnabled ? 1 : 0.4
            }}
            onClick={() => {
              if (isEnabled) onSelect(item);
            }}
          >
            📄 {item.name}
          </div>
        );
      }
    });
  };


return (
    <>
      {/* Grey overlay */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent grey
          zIndex: 9998
        }}
        onClick={onClose} // Clicking outside closes popup
      />
      {/* Popup */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "white",
          border: "1px solid #ccc",
          padding: "20px",
          zIndex: 9999,
          width: "300px",
          maxHeight: "400px",
          overflowY: "auto",
          borderRadius: "8px"
        }}
      >
        <h3>Select a File</h3>
        {renderItems(fileStructure)}
        <button onClick={onClose} style={{ marginTop: "10px" }}>Cancel</button>
      </div>
    </>
  );
}

export default FilePopup;
